// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__3bc_Q","logo_collapsed":"style_logo_collapsed__PJ8S2"};